import { useEffect, useRef, useState } from 'react';

import { currencies } from '@/services/setting';
import { ICurrentItem } from '@/services/types/settings';
import { useUserStore } from '@/store/useUser';
import { complianceExtData } from '@/utils/complianceHelpers';

const useCurrency = () => {
  const [currencyList, setCurrencyList] = useState<ICurrentItem[]>([]);
  const [showCurrencyOfflineModal, setShowCurrencyOfflineModal] = useState('');
  const getCurrencyListPromise = useRef<Promise<ICurrentItem[]>>();
  const { complianceConfig } = useUserStore();

  const getCurrencies = async () => {
    const complianceConfigCurrencyList = complianceExtData(
      complianceConfig?.CurrencyList,
    );
    if (complianceConfigCurrencyList?.list?.length) {
      getCurrencyListPromise.current = Promise.resolve(
        complianceConfigCurrencyList?.list || [],
      ) as unknown as Promise<ICurrentItem[]>;
    } else {
      getCurrencyListPromise.current = currencies() as unknown as Promise<
        ICurrentItem[]
      >;
    }
    getCurrencyListPromise.current.then((result) => {
      setCurrencyList(result.filter((item) => item.is_offline === 0));
    });
  };

  const checkUserCurrencyCode = (code: string) => {
    return getCurrencyListPromise.current?.then((result) => {
      if (code && result?.length) {
        const currency = result.find((item) => item.code === code);
        if (!currency || currency?.is_offline === 1) {
          isShowCurrencyOfflineModal(currency?.code || code);
          return {
            is_offline: 1,
          };
        } else {
          return {
            is_offline: 0,
          };
        }
      }
    });
  };

  const isShowCurrencyOfflineModal = (code: string) => {
    const key = `alertCurrencyOfflineTime_${code}`;
    const alertUserCurrencyOfflineTime = localStorage.getItem(key) || 0;
    if (+alertUserCurrencyOfflineTime < 3) {
      setShowCurrencyOfflineModal(code);
    } else {
      setShowCurrencyOfflineModal('');
    }
  };

  useEffect(() => {
    getCurrencies();
  }, []);

  return {
    currencyList,
    checkUserCurrencyCode,
    showCurrencyOfflineModal,
  };
};

export default useCurrency;
